// src/components/admin/DisputeStatusBadge.tsx
// ============================================================
// Summit League v2 — Dispute Status Badge
//
// Color-coded pill displaying the current dispute status.
// ============================================================

import React from 'react';

type DisputeStatus =
  | 'open'
  | 'under_review'
  | 'resolved_team_a'
  | 'resolved_team_b'
  | 'resolved_draw'
  | 'dismissed';

interface DisputeStatusBadgeProps {
  status: DisputeStatus;
}

const STATUS_CONFIG: Record<DisputeStatus, { label: string; className: string }> = {
  open: { label: 'Open', className: 'sl-dispute-badge--open' },
  under_review: { label: 'Under Review', className: 'sl-dispute-badge--review' },
  resolved_team_a: { label: 'Resolved (Team A)', className: 'sl-dispute-badge--resolved' },
  resolved_team_b: { label: 'Resolved (Team B)', className: 'sl-dispute-badge--resolved' },
  resolved_draw: { label: 'Draw', className: 'sl-dispute-badge--resolved' },
  dismissed: { label: 'Dismissed', className: 'sl-dispute-badge--dismissed' },
};

export default function DisputeStatusBadge({ status }: DisputeStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || { label: status, className: '' };

  return (
    <span className={`sl-dispute-badge ${config.className}`}>
      {config.label}
    </span>
  );
}
